<template>
    <pc-capsule
        id="IncentiveMetadataCapsule"
        v-bind:shown="showCapsule"
        v-bind:title="title"
        has-body
        v-on:update:shown="showCapsule = $event">
        <pc-input
            v-for="m in incentiveMetadata"
            v-bind:key="m.MetadataFieldPublicId"
            v-model="m.MetadataValue"
            v-bind:readonly="readonly"
            v-bind:label="metadataInputLabel(m.MetadataFieldPublicId)"
            v-bind:inputmode="metadataInputMode(m.MetadataFieldPublicId)"
            v-bind:validator="metadataValidator(m.MetadataFieldPublicId)"
            v-bind:data-test-role="getTestRole(m.MetadataFieldPublicId)"
            validation-enabled
            class="mb-3"
            v-on:update:model-value="onUpdateModelValue" />
    </pc-capsule>
</template>
<script>
    import { METADATA_TYPE } from "./incentiveDesignList.vue";
    import { VALIDATOR_TYPES, getValidator } from "Validation/validator";

    export default {
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            title: { type: String, required: true },
            readonly: { type: Boolean, required: true },
            metadataFields: { type: Array, required: true },
            incentiveMetadata: { type: Array, required: true }
        },
        emits: ["metadata-updated"],
        data() {
            const decimalValidator = getValidator(this.$app, VALIDATOR_TYPES.decimal);
            const alwaysValidator = getValidator(this.$app, VALIDATOR_TYPES.alwaysValid);
            return {
                showCapsule: true,
                decimalValidator,
                alwaysValidator
            };
        },
        methods: {
            metadataField(metadataFieldId) {
                return this.metadataFields.find((m) => m.PublicId === metadataFieldId);
            },
            metadataFieldType(metadataFieldId) {
                const mfld = this.metadataField(metadataFieldId);
                if (mfld) {
                    return mfld.DataFieldTypeConstantId;
                }
                return METADATA_TYPE.Text;
            },
            metadataInputLabel(metadataFieldId) {
                const mfld = this.metadataField(metadataFieldId);
                if (mfld) {
                    return mfld.SchemaRowName;
                }
                return "";
            },
            metadataInputMode(metadataFieldId) {
                if (this.metadataFieldType(metadataFieldId) === METADATA_TYPE.Decimal) {
                    return "decimal";
                }
                return null;
            },
            metadataValidator(metadataFieldId) {
                if (this.metadataFieldType(metadataFieldId) === METADATA_TYPE.Decimal) {
                    return this.decimalValidator;
                }
                return this.alwaysValidator;
            },
            getTestRole(metadataFieldId) {
                const label = this.metadataInputLabel(metadataFieldId);
                return label.replaceAll(" ", "-").toLowerCase();
            },
            onUpdateModelValue(value) {
                this.$emit("metadata-updated", value);
            }
        }
    };
</script>
